import { css } from '@emotion/react';
import React from 'react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import {
  openSans,
} from 'styles/global_defaults/fonts';


type Props = {
  className?: string,
  style?: React.CSSProperties,
};

const UnmetRequirementOverlay = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    style,
    className,
  } = props;

  const styles = css`
    .info {
      font-family: ${openSans};
    }
  `;

  return (
    <div
      ref={ref}
      css={styles}
      style={style}
      className={`d-flex flex-column justify-content-center text-align-center color-white ${className ? `${className}` : ''}`}
    >
      <NvIcon
        icon='ban'
        size='small'
        className='mb-3'
      />
      <div className='info text-small color-white font-weight-bold'>{t.OFFERINGS.CARD.UNMET_REQUIREMENT()}</div>
    </div>
  );
});

export default UnmetRequirementOverlay;
